import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { InvoiceBookItem } from '../../../services/apps/invoices/invoices-book.service';

export interface CancelInvoiceDialogData {
  invoice: InvoiceBookItem;
  reversesPlanCoverage?: boolean;
}

@Component({
  selector: 'app-cancel-invoice-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    TablerIconsModule
  ],
  template: `
    <div class="cancel-invoice-dialog">
      <div class="dialog-header">
        <h2 mat-dialog-title class="dialog-title">
          <mat-icon color="warn" class="me-2">warning</mat-icon>
          Cancelar Factura
        </h2>
        <button mat-icon-button (click)="onCancel()" aria-label="Cerrar" class="dialog-close-btn">
          <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
        </button>
      </div>
      
      <mat-dialog-content>
        <div class="invoice-info mb-3">
          <p><strong>Número:</strong> {{ data.invoice.invoiceNumber }}</p>
          <p><strong>Cliente:</strong> {{ data.invoice.customerName }}</p>
          <p><strong>Fecha:</strong> {{ data.invoice.issueDate | date: 'dd/MM/yyyy' }}</p>
          <p><strong>Total:</strong> {{ data.invoice.total | currency: data.invoice.currency }}</p>
        </div>
        
        <div class="warning-message p-3 mb-3" style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px;">
          <mat-icon color="warn" class="me-2">warning</mat-icon>
          <strong>Advertencia:</strong> Esta acción no se puede deshacer. La factura será marcada como cancelada.
          <div *ngIf="data.reversesPlanCoverage" class="mt-2 text-danger">
            <strong>Atención:</strong> Esta factura otorga cobertura al abono del cliente. Al anularla o revertirla, se pierde la cobertura de ese período si no existen otros pagos que lo cubran, pero el abono no se da de baja.
          </div>
        </div>
        
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Motivo de cancelación (opcional)</mat-label>
          <textarea matInput 
                    [(ngModel)]="cancelReason" 
                    placeholder="Ingrese el motivo de la cancelación..."
                    rows="3">
          </textarea>
        </mat-form-field>
      </mat-dialog-content>
      
      <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>
        <button mat-raised-button color="warn" (click)="onConfirm()">
          <mat-icon>cancel</mat-icon>
          Confirmar Cancelación
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .cancel-invoice-dialog {
      min-width: 400px;
    }

    .invoice-info p {
      margin: 0.5rem 0;
    }

    .warning-message {
      display: flex;
      align-items: center;
    }

    .dialog-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }
    .dialog-close-btn { flex: 0 0 auto; }
  `]
})
export class CancelInvoiceDialogComponent {
  cancelReason: string = '';

  constructor(
    public dialogRef: MatDialogRef<CancelInvoiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CancelInvoiceDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      reason: this.cancelReason
    });
  }
}
